var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgArrowRightTiny = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 18 34"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.389 17 .694 30.694a1.375 1.375 0 0 0 1.945 1.945l14.667-14.667a1.375 1.375 0 0 0 0-1.944L2.639 1.36A1.375 1.375 0 0 0 .694 3.305L14.39 17z"
})));
export default SvgArrowRightTiny;